//////// POINTS MAP EXAMPLE ///////////////////////

// for mobile view - bound to LA city
export const BOUNDS_SMALL = [-118.965411, 33.72144, -117.81778, 34.285528];
// for desktop view - bound to LA city - WSEN
export const BOUNDS_LARGE = [-119.25658, 33.5024226, -116.841974, 34.29202];

export const ALTADENA_BOUNDS = [
  -118.1631571075, 34.16534036109374, -118.11177819249998, 34.22084793890626,
];
export const PALISADES_BOUNDS = [
  -118.57669828499999, 34.024131377812495, -118.51747051499999,
  34.0881185221875,
];
// from mapbox
export const STYLE = `mapbox://styles/latimes/cm9reamdj00gw01rmadt9fqvy${
  process.env.NODE_ENV === 'development' ? '/draft' : ''
}`;
// export const STYLE = `mapbox://styles/latimes/cm9reamdj00gw01rmadt9fqvy`;
export const TILESET = 'mapbox://latimes.29dnxolk';

// this can be found on your tileset - on the right rail, look for "Vector layers" - there should be a name of the source layer right under that label
export const SOURCE_LAYER = 'combined-soil-data-rates-8sqnxh';

// you can leave these as is or create a new source name if you want
export const SOURCE = 'source';
export const TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
